export const ADMIN = 0; //Running in admin app mode
export const BUILD = 1; //Running in site generator app mode
